// extracted by mini-css-extract-plugin
export var wrapperStyle = "sr_section-module--wrapperStyle--apTOG";